module.exports = __webpack_public_path__ + "static/media/camera-outlined.58ecd005.svg";